import { Navigate } from "react-router";
import { useSelector } from "react-redux";

const ProtectedRoute = ({ allowedRoles, children }) => {
  const { isAuthenticated } = useSelector((state) => state.auth);
  const userType = localStorage.getItem("userType");

  if (!isAuthenticated || !allowedRoles.includes(userType)) {
    return <Navigate to="/login" replace />;
  }
  return children;
};

export default ProtectedRoute;
